import gql from 'graphql-tag';
import { DocumentNode } from 'graphql';

//#region 비디오 리스트를 가지고 옵니다.
const GET_VIDEO_LIST: DocumentNode = gql`
    query videoList($category: Int){
        videoList(category:$category) {
            video_list_no
            video_name
            url
            image_url
            contents
            view_count
            runtime
            created_at
            updated_at
            category{
                id
                name
            }
            video_play_space {
                space
                explain
            }
        }
    }
`;
//#endregion

//#region 비디오의 view 카운트를 상승 시킵니다
const ADD_VIDEO_VIEW_COUNT: DocumentNode = gql`
    mutation addVideoDetailCount($videoListNo: Int!) {
        addVideoDetailCount(videoListNo: $videoListNo) {
            video_list_no
            video_name
            url
            image_url
            view_count
            runtime
            updated_at
            created_at
        }
    }
`;
//#endregion

const GET_USER_INFO: DocumentNode = gql`
    query {
        userInfo {
            name
            email
            user_default_email
            phone
            companyName
        }
    }
`;

export { GET_VIDEO_LIST, ADD_VIDEO_VIEW_COUNT, GET_USER_INFO };
